import { FC } from 'react';
import colors from 'styles/_colors.module.scss';

const WalletIconSignature: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    fill="none"
    viewBox="0 0 14 14"
  >
    <path
      fill={colors['--pink-500']}
      d="M8.021.772a2.445 2.445 0 013.458 3.457l-.272.271.086.086a2 2 0 010 2.828l-1.44 1.44a.5.5 0 01-.707-.707l1.44-1.44a1 1 0 000-1.414l-.086-.086-5.646 5.647a.5.5 0 01-.233.131l-4 1a.5.5 0 01-.595-.643l1.25-3.75a.5.5 0 01.12-.195L8.021.772zm2.75.707a1.445 1.445 0 00-2.042 0L2.187 8.02l-.925 2.774 2.982-.745 6.527-6.527a1.445 1.445 0 000-2.043zM3.967 14c-1.235 0-2.208-.566-2.855-1.107l1.284-.32a3.2 3.2 0 001.57.427c.406 0 .824-.164 1.27-.457.447-.293.878-.687 1.314-1.095l.113-.107c.385-.36.784-.737 1.166-.996.408-.278.95-.53 1.517-.31.376.143.62.41.79.735.162.306.273.688.38 1.105.05.19.134.374.23.498.032.044.07.082.115.112.025.015.036.015.039.015.122 0 .33-.082.63-.286.185-.126.344-.252.502-.379.098-.078.197-.157.302-.235.279-.209.52-.349.697-.438.09-.046.183-.087.278-.124l.02-.008.007-.002h.003l.16.472-.158-.474a.5.5 0 01.32.947l-.003.002c-.06.024-.118.05-.175.08-.13.064-.321.174-.55.346-.06.043-.135.104-.223.174-.181.143-.41.324-.618.466-.31.212-.741.46-1.192.46-.436 0-.751-.265-.946-.517a2.435 2.435 0 01-.405-.858c-.11-.423-.196-.7-.296-.89-.09-.168-.17-.232-.266-.27-.082-.03-.245-.033-.595.206-.313.212-.655.533-1.058.912l-.1.093c-.431.405-.92.855-1.45 1.202-.53.348-1.14.621-1.817.621z"
    />
  </svg>
);

export default WalletIconSignature;
